'use strict';

const getAuthToken = (_location) => {
  let location = _location || window.location;
  let queryParamsString = location.search.substr(1);
  const params = new URLSearchParams(queryParamsString);

  return [
      params.get('user_id'),
      params.get('auth_token'),
      params.get('expires'),
      params.get('employee_id'),
  ];
};

module.exports = getAuthToken;
